import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InteractionType } from '@azure/msal-browser';
import { AuthenticatedTemplate, MsalAuthenticationTemplate, MsalProvider, UnauthenticatedTemplate } from '@azure/msal-react';
import { loginRequestB2B } from '../..';
import { useSession } from '../../../shell';
export function AuthenticationBoundary({ children }) {
    const session = useSession();
    return (_jsx(MsalProvider, { instance: session, children: _jsxs(MsalAuthenticationTemplate, { interactionType: InteractionType.Redirect, authenticationRequest: loginRequestB2B(), children: [_jsx(AuthenticatedTemplate, { children: children }), _jsx(UnauthenticatedTemplate, { children: _jsx("h1", { children: "Error, you are not signed-in." }) })] }) }));
}
